import { Button, PrevButton, ButtonGroup } from '../ESignApplicationContainer.jsx';
import AgreementLayout from './AgreementLayout';
import { useNavigate } from 'react-router-dom';
import { useESign } from '../eSignApplicationContext';
import useIsMobile from '../hooks/useIsMobile.jsx';
import { ROUTES } from 'App';
import useBusinessNumber from '../hooks/useBusinessNumber.jsx';
import useRedirect from '../hooks/useRedirect.jsx';

const AgreementStep = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { checkedList } = useESign();
  const { businessNumber } = useBusinessNumber();
  const { redirectUrl } = useRedirect();

  const getIsAllTermsChecked = () => checkedList.slice(0, -1).every((v) => v);

  const moveToNext = async () => {
    const allTermsChecked = getIsAllTermsChecked();

    if (!allTermsChecked) {
      alert('필수 항목을 확인해 주세요');
      return;
    }

    navigate(
      `${ROUTES.eSignSign}?businessNumber=${businessNumber}${redirectUrl ? `&redirectUrl=${redirectUrl}` : ''}`
    );
  };

  const moveToPrev = () => {
    navigate(
      `${ROUTES.eSignContract}?businessNumber=${businessNumber}${redirectUrl ? `&redirectUrl=${redirectUrl}` : ''}`
    );
  };

  return (
    <>
      {/* 화면용 렌더링 */}
      <AgreementLayout isMobile={isMobile} documentRef={null} />

      <ButtonGroup>
        <PrevButton onClick={moveToPrev}>이전 페이지</PrevButton>
        <Button onClick={moveToNext} disabled={!getIsAllTermsChecked()}>
          다음 페이지
        </Button>
      </ButtonGroup>
    </>
  );
};

export default AgreementStep;
